module.exports = __webpack_public_path__ + "media/images/clearcash-growth-6394a94babf875956abc3c9e952eb64c.png";